import {
    ButtonState,
    DEVICE_STATUS,
    DEVICE_TYPE,
    TAB_TYPE,
} from './../../types/pages/storeManagement/registration/registrationTypes';
import { useMemo } from 'react';
import { useRegistrationState } from '@/provider/registration/registrationContext';
import { REGISTRATION_MODE } from '@/types/pages/storeManagement/registration/registrationTypes';
import { deriveInfraDeviceState } from '@/utils/registrationUtils';

export const useRegistrationButtonState = () => {
    const { state } = useRegistrationState();
    return useMemo(() => {
        const isInstallationMode = state.registrationMode === REGISTRATION_MODE.INSTALLATION_MODE;
        const { hasApConfirmed, hasApUnlock, hasRTConfirmed, hasAP } = deriveInfraDeviceState(state.infraDevice);
        const checkDeleteBtnStatus = () => {
            const info = {
                status: false,
                tooltip: '',
                warning: '',
            };
            if (state.deviceInfoState.selectedInfraDevices.length === 0) {
                info.tooltip = 'Select at least one to delete.';
                return info;
            }

            if (state.currentTab === TAB_TYPE.AP) {
                info.status = !hasRTConfirmed;
                info.tooltip = 'Cannot delete: AP has associated routers.';
                if (hasRTConfirmed) {
                    info.warning = 'Cannot delete: AP has associated routers.';
                }
            }
            if (state.currentTab === TAB_TYPE.RT) {
                const macList = state.deviceInfoState.selectedInfraDevices.map((o) => o.mac);
                const tagList = state.infraDevice.filter((o) => o.device_type_id === DEVICE_TYPE.TAG);
                const hasTag = tagList.some(
                    (o) => macList.includes(o.parent_mac) && o.confirmed === DEVICE_STATUS.UN_CONFIRMED,
                );
                info.status = !hasTag;
                info.tooltip = 'Cannot delete: router has associated tags.';
                if (hasTag) {
                    info.warning = 'Cannot delete: router has associated tags.';
                }
            }
            if (state.currentTab === TAB_TYPE.TAG) {
                info.status = true;
                info.tooltip = '';
            }
            return info;
        };
        return {
            delete: checkDeleteBtnStatus(),
            addAP: isInstallationMode && !hasAP,
            addTag: isInstallationMode && hasApConfirmed && hasRTConfirmed,
            refresh: isInstallationMode,
            editAP: isInstallationMode && hasApConfirmed,
            confirmRT: isInstallationMode && hasApUnlock,
        } as ButtonState;
    }, [state.registrationMode, state.infraDevice, state.deviceInfoState.selectedInfraDevices, state.currentTab]);
};
